// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"00c80af0","610":"641cf871","787":"1cdaf62a"}[chunkId] + ".chunk.js";
};